import React,{useState,useEffect} from 'react';
import {pendingAttempts,clearResolvedAttempt} from './financialAttempts';
import {createReceiptRetryState,submitManualTransfer} from './orderReceiptRetry';

const needsReceipts = attempt => Boolean(attempt.manual_storage_key && attempt.payload.payment_method === 'bank_transfer');
const statusPath = attempt => `/${attempt.path.startsWith('/admin/')?'admin':'user'}/request-status/${attempt.flow}/${attempt.payload.client_request_id}`;

export default function FinancialRecovery({token,api,onResolved}) {
  const [attempts,setAttempts]=useState(()=>pendingAttempts(token));
  const [files,setFiles]=useState({});
  useEffect(()=>{const update=()=>setAttempts(pendingAttempts(token));update();window.addEventListener("qolak-financial-attempt",update);return()=>window.removeEventListener("qolak-financial-attempt",update);},[token]);
  const [message,setMessage]=useState('');const [busy,setBusy]=useState(false);
  function receiptState(attempt) {
    const state=createReceiptRetryState(attempt.receipt_scope);
    if(state.current()?.client_request_id!==attempt.payload.client_request_id)throw new Error('وضعیت این درخواست تغییر کرده؛ بخش پیگیری را دوباره باز کنید.');
    return state;
  }
  async function check(attempt) {
    if(busy)return;setBusy(true);setMessage('');
    try {
      const result=await api('GET',statusPath(attempt));
      if(result.committed){
        if(needsReceipts(attempt)){
          receiptState(attempt).attachOrder(result.transaction);
          setMessage(`درخواست ثبت شده است. رسیدهای همان واریز را برای تکمیل ارسال کنید. کد پیگیری: ${result.transaction.tracking_code}`);
        }else{
          clearResolvedAttempt(token,attempt);
          setMessage(`درخواست ثبت شده است. کد پیگیری: ${result.transaction.tracking_code}`);
        }
        setAttempts(pendingAttempts(token));onResolved();
      }
      else setMessage('ثبت این شناسه هنوز تأیید نشده. برای ادامه، همان درخواست را با همان اطلاعات دوباره پیگیری کنید.');
    }catch(error){setMessage(error.message);}finally{setBusy(false);}
  }
  async function replay(attempt) {
    if(busy)return;setBusy(true);setMessage('');
    try{
      let result;
      if(needsReceipts(attempt)){
        const state=receiptState(attempt);
        if(!state.current().tracking_code){
          const status=await api('GET',statusPath(attempt));
          if(status.committed)state.attachOrder(status.transaction);
          else if(attempt.flow!=='wallet_charge'&&state.current().payload.expected_price_per_gram_rial===undefined){
            throw new Error('ثبت درخواست قدیمی هنوز تأیید نشده؛ شناسه و مدارک را برای بررسی به پشتیبانی ارائه کنید. واریز دیگری لازم نیست.');
          }
        }
        const submission=await submitManualTransfer({api,state,payload:state.current().payload,files:files[attempt.payload.client_request_id]||[],createPath:attempt.path,receiptPath:attempt.receipt_path});
        result=submission.order;
      }else{
        result=await api('POST',attempt.path,attempt.payload);
        clearResolvedAttempt(token,attempt);
      }
      setAttempts(pendingAttempts(token));
      setMessage(`${needsReceipts(attempt)?'رسیدهای درخواست ارسال شد':'نتیجهٔ درخواست مشخص شد'}. کد پیگیری: ${result.tracking_code}`);
      onResolved();
    }catch(error){
      if(!needsReceipts(attempt)&&([400,404,405,413,415,422,428].includes(error.status)||error.code==='quote_changed')){clearResolvedAttempt(token,attempt);onResolved();}
      setAttempts(pendingAttempts(token));setMessage(error.message);
    }finally{setBusy(false);}
  }
  if(!attempts.length&&!message)return null;
  return <section className="qc-context-note" style={{display:'block',margin:16}}>
    <strong>پیگیری درخواست‌های ناتمام</strong>
    {attempts.map(attempt=><div key={attempt.payload.client_request_id}>
      {attempt.label&&<p><strong>{attempt.label}</strong></p>}
      <p>شناسهٔ درخواست: <bdi>{attempt.payload.client_request_id}</bdi></p>
      {attempt.tracking_code&&<p>کد پیگیری: <bdi>{attempt.tracking_code}</bdi></p>}
      {needsReceipts(attempt)&&<div>
        <p>رسیدهای همان واریز را به همان ترتیب انتخاب کنید. نیازی به واریز دوباره نیست.</p>
        <p>فایل‌های قبلی: <bdi>{attempt.receipt_names.join('، ')}</bdi></p>
        <label>رسیدهای همان واریز
          <input type="file" accept=".jpg,.jpeg,.png,.webp" multiple disabled={busy} onChange={event=>setFiles(current=>({...current,[attempt.payload.client_request_id]:Array.from(event.target.files||[])}))}/>
        </label>
      </div>}
      <button disabled={busy} onClick={()=>check(attempt)}>بررسی وضعیت ثبت</button>{' '}
      <button disabled={busy} onClick={()=>replay(attempt)}>{needsReceipts(attempt)?'ادامهٔ ارسال رسید':'ادامهٔ همان درخواست'}</button>
    </div>)}
    {message&&<p role="status">{message}</p>}
  </section>;
}
